import { AvatarGroup, Avatar, Typography, getDefaultLogo } from '@weareopenr/component-library';
import { publishChannelsToAvatars, channelToAvatar } from 'src/helpers/channels/channelToAvatar';
import type { IExternalSystem } from 'src/helpers/channels/channelToAvatar';
import styles from './ChannelAvatarTooltip.module.scss';

export type { IExternalSystem };

export const ChannelAvatarTooltip = ({ externalSystems }: { externalSystems: IExternalSystem[] }) => (
  <AvatarGroup avatars={publishChannelsToAvatars(externalSystems)}>
    <div className={styles['channel-tooltip']}>
      {externalSystems.map((system) => {
        const { variant, initials, brand } = channelToAvatar(system);
        return (
          <div key={system.name} className={styles['channel-tooltip-item']}>
            <Avatar variant={variant} initials={initials} imageUrl={getDefaultLogo(brand)} />
            <Typography colour="secondary">{system.name}</Typography>
          </div>
        );
      })}
    </div>
  </AvatarGroup>
);

export default ChannelAvatarTooltip;
